import { Col, Form, Input, Row } from "antd";
import { Button as BootstrapButton } from "react-bootstrap";
import { EmployeeConfigType } from "../../../../../../../services/config/permission-config/employeeRole";
import { RegExp } from "../../../../../../../constants";
import { AlternatePeoplePicker } from "../../../../../../../components/select/alternate-people-picker";

interface ConfigEmployeeFormProps {
  onSubmit: (values: any) => void;
  employee: EmployeeConfigType;
  isAddUser: boolean;
}

export const EmployeeConfigForm = (props: Partial<ConfigEmployeeFormProps>) => {
  const { onSubmit = () => {}, employee, isAddUser } = props;
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    onSubmit({ ...(employee ?? {}), ...values });
  };

  return (
    <Form
      name="dynamic_form_nest_item"
      autoComplete="off"
      form={form}
      size="large"
      layout="vertical"
      onFinish={onFinish}
      initialValues={employee}
    >
      {isAddUser ? (
        <Form.Item label="Thành viên" name="employee">
          <AlternatePeoplePicker placeholder="Thêm thành viên" />
        </Form.Item>
      ) : (
        <Row gutter={[32, 0]}>
          <Col span={24}>
            <Form.Item
              required
              label="Họ và tên"
              name="name"
            >
              <Input disabled={true} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              required
              label="Email"
              name="email"
              rules={[
                {
                  type: "email",
                  message: "E-mail không hợp lệ!",
                },
                {
                  message: "E-mail phải kết thúc bằng @viags.vn!",
                  pattern: RegExp.viagsEmail,
                },
                {
                  required: true,
                  message: "Vui lòng nhập E-mail!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Ghi chú" name="note">
              <Input />
            </Form.Item>
          </Col>
        </Row>
      )}
      <div className="flex-end">
        <BootstrapButton variant="success" type="submit">
          Xác nhận
        </BootstrapButton>
      </div>
    </Form>
  );
};
